/**
 * Base class for visualization
 */
export default class Transformation {
  constructor(config) {
    this.config = config;
    this._emitter = () => {};
  }

  /**
   * return {
   *   template : angular template string or url (url should end with .html),
   *   scope : an object to bind to template scope
   * }
   */
  getSetting() {
    // override this
  }

  /**
   * Method will be invoked when tableData or config changes
   */
  transform(tableData) {
    // override this
  }

  /**
   * render setting
   */
  renderSetting(targetEl) {
    let setting = this.getSetting();
    if (!setting) {
      return;
    }

    // already readered
    if (this._scope) {
      let self = this;
      this._scope.$apply(function() {
        for (let k in setting.scope) {
          if(setting.scope.hasOwnProperty(k)) {
            self._scope[k] = setting.scope[k];
          }
        }

        for (let k in self._prevSettingScope) {
          if (!setting.scope[k]) {
            self._scope[k] = setting.scope[k];
          }
        }
      });
      return;
    } else {
      this._prevSettingScope = setting.scope;
    }

    let scope = this._createNewScope();
    for (let k in setting.scope) {
      if(setting.scope.hasOwnProperty(k)) {
        scope[k] = setting.scope[k];
      }
    }
    let template = setting.template;

    if (template.split('\n').length === 1 &&
        template.endsWith('.html')) { // template is url
      let self = this;
      this._templateRequest(template).then(function(t) {
        self._render(targetEl, t, scope);
      });
    } else {
      this._render(targetEl, template, scope);
    }
  }

  _render(targetEl, template, scope) {
    this._targetEl = targetEl;
    targetEl.html(template);
    this._compile(targetEl.contents())(scope);
    this._scope = scope;
  }

  setConfig(config) {
    this.config = config;
  }

  /**
   * Emit config. config will sent to server and saved.
   */
  emitConfig(config) {
    this._emitter(config);
  }
}
